import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import util from 'Utils/commonUtil';

class DialogImage extends React.Component {
    scrollTop = 0;
    scrollLeft = 0;
    animationTime = 300;
    isBindDisableScroll = false;
    created = false;
    state = {
        opened: false,
        // Mask default style.
        defaultMaskStyle: {
            width: '100%',
            height: '100%',
            display: 'none',
            transitionDuration: this.animationTime + 'ms',
            transitionProperty: 'opacity',
            position: 'absolute',
            left: 0,
            top: 0,
        },
        // Content default style.
        defaultContentStyle: {
            left: 0,
            top: 0,
        },
    };

    componentWillMount() {
        if (util.isBoolean(this.props.opened) && this.props.opened === true) {
            this.created = true;
        } else {
            this.created = false;
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);

        if (util.isBoolean(this.props.opened) && this.props.opened === true) {
            this.setMaskPosition();
            this.openDialog();
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (
            util.isBoolean(nextProps.opened)
                ? this.props.opened !== nextProps.opened
                : this.state.opened !== nextState.opened
        ) {
            if (
                util.isBoolean(nextProps.opened)
                    ? nextProps.opened
                    : nextState.opened
            ) {
                this.created = true;
                this.setMaskPosition();
            } else {
                this.created = false;
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            util.isBoolean(this.props.opened)
                ? this.props.opened !== prevProps.opened
                : this.state.opened !== prevState.opened
        ) {
            if (
                util.isBoolean(this.props.opened)
                    ? this.props.opened
                    : this.state.opened
            ) {
                this.openDialog();
            } else {
                this.closeDialog();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
        this.disableScroll(false);
    }

    resize = () => {
        this.setMaskPosition();
    };

    setMaskPosition = () => {
        const {left} = util.getScrollPos();
        const {defaultMaskStyle} = this.state;

        if (util.isPhone() && util.isIOS()) {
            defaultMaskStyle.top = 0;
            defaultMaskStyle.left = 0;
        } else {
            defaultMaskStyle.position = 'fixed';
            defaultMaskStyle.top = 0 + 'px';
            defaultMaskStyle.left = left + 'px';
        }

        this.setState({defaultMaskStyle});
    };

    setContentPostion = () => {
        const {defaultContentStyle} = this.state;

        if (
            util.isBoolean(this.props.opened)
                ? this.props.opened
                : this.state.opened
        ) {
            const dialogMask = ReactDOM.findDOMNode(this);
            const dialogWrap = dialogMask.children[0];
            const clientWidth = dialogMask.clientWidth;
            const clientHeight = dialogMask.clientHeight;

            if (clientWidth < dialogWrap.offsetWidth) {
                defaultContentStyle.left = 0;
            } else {
                defaultContentStyle.left = '50%';
                if (clientHeight < dialogWrap.offsetHeight) {
                    defaultContentStyle.transform = 'translateX(-50%)';
                } else {
                    defaultContentStyle.transform = 'translate(-50%, -50%)';
                }
            }

            if (clientHeight < dialogWrap.offsetHeight) {
                defaultContentStyle.top = 0;
            } else {
                defaultContentStyle.top = '50%';
                if (clientWidth < dialogWrap.offsetWidth) {
                    defaultContentStyle.transform = 'translateY(-50%)';
                } else {
                    defaultContentStyle.transform = 'translate(-50%, -50%)';
                }
            }
        }

        this.setState({defaultContentStyle});
    };

    css(dom, obj) {
        Object.keys(obj).forEach((styleName) => {
            dom.style[styleName] = obj[styleName];
        });
    }

    /**
     * Open dialog
     */
    openDialog() {
        const {defaultMaskStyle} = this.state;

        this.disableScroll(true);

        defaultMaskStyle.display = 'block';

        this.setState({defaultMaskStyle}, () => {
            defaultMaskStyle.opacity = 1;

            this.setState({opened: true, defaultMaskStyle}, () => {
                this.setContentPostion();
            });
        });
    }

    /**
     * Close dialog
     */
    closeDialog = () => {
        // If click or touch event run setState.
        const {defaultMaskStyle} = this.state;

        defaultMaskStyle.opacity = 0;

        this.setState({defaultMaskStyle}, () => {
            window.setTimeout(() => {
                this.disableScroll(false);

                defaultMaskStyle.display = 'none';

                this.setState({defaultMaskStyle});
            }, this.animationTime);
        });

        if (util.isFunction(this.props.dialogDidClose))
            this.props.dialogDidClose();
    };

    disableScroll = (opened) => {
        const body = document.getElementById('root');
        const dialogMask = ReactDOM.findDOMNode(this);
        const {top, left} = util.getScrollPos();

        if (util.isAndroid() && !this.isBindDisableScroll) {
            this.isBindDisableScroll = true;

            dialogMask &&
                dialogMask.addEventListener('touchstart', (ev) => {
                    const startTouchPointY = ev.touches[0].clientY;

                    function touchmove(ev) {
                        const currentTouchPointY = ev.touches[0].clientY;
                        const scrollTopMax =
                            dialogMask.scrollHeight - dialogMask.offsetHeight;

                        if (
                            startTouchPointY < currentTouchPointY &&
                            dialogMask.scrollTop <= 0
                        ) {
                            ev.preventDefault();
                        } else if (
                            startTouchPointY > currentTouchPointY &&
                            dialogMask.scrollTop >= scrollTopMax
                        ) {
                            ev.preventDefault();
                        }
                    }

                    function touchend() {
                        dialogMask &&
                            dialogMask.removeEventListener(
                                'touchmove',
                                touchmove,
                            );
                        dialogMask &&
                            dialogMask.removeEventListener(
                                'touchend',
                                touchend,
                            );
                    }

                    dialogMask.addEventListener('touchmove', touchmove);
                    dialogMask.addEventListener('touchend', touchend);
                });
        }

        if (opened) {
            this.scrollLeft = left;
            this.scrollTop = top;
            if (window.disabledBodyScroll) window.disabledBodyScroll++;
            else window.disabledBodyScroll = 1;

            if (util.isPhone() && util.isIOS()) {
                body.style.width = '100%';
                body.style.height = '100%';
                body.style.position = 'fixed';
                body.style.left = -this.scrollLeft + 'px';
                body.style.top = -this.scrollTop + 'px';
            } else {
                body.style.overflow = 'hidden';
            }
        } else {
            if (window.disabledBodyScroll) window.disabledBodyScroll--;
            if (window.disabledBodyScroll) return;

            if (util.isPhone() && util.isIOS()) {
                body.style.width = '';
                body.style.height = '';
                body.style.position = '';
                body.style.left = '';
                body.style.top = '';
                document.getElementsByTagName(
                    'body',
                )[0].scrollTop = this.scrollTop;
                document.getElementsByTagName(
                    'body',
                )[0].scrollLeft = this.scrollLeft;
            } else {
                body.style.overflow = '';
            }
        }
    };

    addClassName(element, className) {
        let classNameList = element.className
            ? element.className.split(' ')
            : [];

        if (classNameList.indexOf(className) === -1) {
            classNameList.push(className);
            element.className = classNameList.join(' ');
        }

        return element;
    }

    removeClassName(element, className) {
        let classNameList = element.className
            ? element.className.split(' ')
            : [];
        let index = classNameList.indexOf(className);

        if (index !== -1) {
            classNameList.splice(index, 1);
            element.className = classNameList.join(' ');
        }

        return element;
    }

    clickBgClose = (ev) => {
        const options = this.props.options || {};

        if (options.bgClickClose) this.closeDialog();
    };

    render() {
        if (this.created) {
            return ReactDOM.createPortal(
                <div
                    className="dialog-mask"
                    style={{
                        ...this.state.defaultMaskStyle,
                        ...this.props.maskStyle,
                    }}
                    {...util.clickOfSingleTap(this.clickBgClose)}>
                    <div
                        className="dialog-warp"
                        style={{...this.state.defaultContentStyle}}>
                        <div
                            className="dialog-content container-max-width"
                            style={this.props.contentStyle}
                            {...util.clickOfSingleTap(null, {
                                isStopPropagation: true,
                            })}>
                            {this.props.children}
                        </div>
                    </div>
                </div>,
                document.getElementsByTagName('body')[0],
            );
        }

        return null;
    }
}

DialogImage.propTypes = {
    opened: PropTypes.bool,
    options: PropTypes.object,
    maskStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    children: PropTypes.node,
    dialogWillOpen: PropTypes.func,
    dialogDidOpen: PropTypes.func,
    dialogWillClose: PropTypes.func,
    dialogDidClose: PropTypes.func,
};

DialogImage.defaultProps = {
    options: {},
    maskStyle: {},
    contentStyle: {},
};

export default DialogImage;
